const reducerTypes = {
  POSTS_PENDING: "POSTS_PENDING",
  POSTS_SUCCESS: "POSTS_SUCCESS",
  POSTS_FAILED: "POSTS_FAILED",
  USER_POSTS_SUCCESS: "USER_POSTS_SUCCESS",
  SELECTED_POST_SUCCESS: "SELECTED_POST_SUCCESS",
  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
  ADD_POST: "ADD_POST",
  DELETE_POST: "DELETE_POST",
  EDIT_POST: "EDIT_POST",
  ADD_COMMENT: "ADD_COMMENT",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGOUT: "LOGOUT",
};

export default reducerTypes;
